import { Injectable } from '@angular/core';
import {
    User,
    UserStub,
    UnknownUserId,
    UserStubWithState
} from '../core-data-model/User.model';
import { TranslationService } from '../translations';

@Injectable({ providedIn: 'root' })
export class UserFactory {
    private static unknownUser: UserStub;

    constructor(private TR: TranslationService) {}

    new_UserStub(obj?: Partial<UserStub>) {
        return new UserStub(this.TR, obj);
    }
    new_UserToStubWithState(obj?: Partial<User>) {
        return new UserStubWithState(this.TR, obj);
    }

    new_User(obj?: Partial<User>) {
        return new User(this.TR, obj);
    }

    getUnknownUser() {
        return UserFactory.unknownUser
            ? UserFactory.unknownUser
            : new UserStub(this.TR, {
                  id: UnknownUserId,
                  firstName: UnknownUserId,
                  lastName: UnknownUserId,
                  email: UnknownUserId
              });
    }
}
